import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../components/Carousel.css';
import logoImage from '../assets/logo.jpg';
import slide1 from '../assets/new-icon-robinhood.jpg';
import slide2 from '../assets/slide-2.png';
import slide3 from '../assets/slide-3.jpg';
import slide4 from '../assets/slide-4d.png';
import fatima17 from '../assets/Fatima_17.jpeg';
import soleMare from '../assets/Sole_mare.jpg';
import slider1Evento6Giugno from '../assets/slider1-evento-6-giugno.png';
import slide5 from '../assets/slide-5.png';
import paperoSinistra from '../assets/papero-sinistra.png';
import paperoDestra from '../assets/papero-destra.png';
import martelli_img from '../assets/Maurizio_Martelli.JPG';
import breccia_img from '../assets/Massimo_Breccia.png';
import barberi_img from '../assets/Walter_Barberi.jpg';
import montanari_img from '../assets/Marta_Montanari.jpg';
import palumbo_img from '../assets/Giovanna_Palumbo.png';
import CV_Maurizio_Martelli from '../assets/CV_Maurizio_Martelli.pdf';
import CV_Massimo_Breccia from '../assets/CV_Massimo_Breccia.pdf';
import CV_Walter_Barberi from '../assets/CV_Walter_Barberi.docx';
import CV_Giovanna_Palumbo from '../assets/CV_Giovanna_Palumbo.pdf';
import locandinaEvento from '../assets/Locandina_RobinHood_evento_18_ottobre 2025-1.png';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex justify-end">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

const PreloadImages = ({ images, onLoad }) => {
  useEffect(() => {
    let loadedImages = 0;
    const imagePromises = images.map(src => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          loadedImages++;
          if (loadedImages === images.length) {
            onLoad();
          }
          resolve();
        };
        img.onerror = reject;
      });
    });

    Promise.all(imagePromises)
      .catch(error => {
        console.error('Error preloading images:', error);
        onLoad(); // Show content even if some images fail to load
      });
  }, [images, onLoad]);

  return null;
};

const Home = () => {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const carouselImages = [slide5, fatima17, slide1, slide2];
  const handleDownloadCV = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Maurizio_Martelli;
    link.download = 'CV_Maurizio_Martelli.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadCV2 = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Massimo_Breccia;
    link.download = 'CV_Massimo_Breccia.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadCV3 = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Walter_Barberi;
    link.download = 'CV_Walter_Barberi.docx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadCV4 = () => {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = CV_Giovanna_Palumbo;
    link.download = 'CV_Giovanna_Palumbo.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="bg-white overflow-hidden">
      {/* Hero Section with improved background color and animation effects */}
      <PreloadImages 
        images={carouselImages} 
        onLoad={() => setImagesLoaded(true)} 
      />
      <section className="relative text-white overflow-hidden w-full flex justify-center">
        {!imagesLoaded ? (
          <div className="w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px] bg-gray-200 animate-pulse flex items-center justify-center">
            <div className="text-gray-400">Loading...</div>
          </div>
        ) : (
        <Slider
          dots={true}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          autoplay={false}
          arrows={true}
          className="carousel-slider w-full"
          prevArrow={<button className="slick-prev" aria-label="Previous" type="button">Previous</button>}
          nextArrow={<button className="slick-next" aria-label="Next" type="button">Next</button>}
          responsive={[
            {
              breakpoint: 768,
              settings: {
                arrows: true
              }
            }
          ]}
        >
          {/* Slide 1 - 5xmille (slide-5) */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px] bg-white">
            <div className="absolute inset-0">
              <img
                src={slide5}
                alt="Robin Hood Roma - Il futuro ha bisogno di ali: dona il tuo 5xmille - C.F. 97353740588"
                className="w-full h-full object-contain object-center"
              />
            </div>
          </div>

          {/* Slide 1 - Evento 6 giugno (COMMENTATA - sostituita da slide-5.png) */}
          {/*
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px] bg-white">
            <div className="absolute inset-0">
              <img
                src={slider1Evento6Giugno}
                alt="Robin Hood Orienteering - Villa Torlonia 6 giugno 2026"
                className="w-full h-full object-contain object-center"
              />
            </div>
            <Link
              to="/eventi"
              state={{ openUpcomingEventId: 2 }}
              className="absolute top-[22%] right-[38%] px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 bg-red-600 hover:bg-red-700 text-white font-bold text-xs sm:text-sm md:text-base rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 text-center leading-tight"
            >
              Per saperne<br />di più!
            </Link>
            <Link
              to="/eventi"
              state={{ openUpcomingEventId: 1 }}
              className="absolute bottom-[2%] right-[13.5%] px-1.5 sm:px-2 md:px-3 py-0.5 sm:py-1 md:py-1.5 bg-green-700 hover:bg-green-800 text-white font-bold text-xs sm:text-sm md:text-base rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 text-center leading-tight"
            >
              Per saperne di più<br />e...<br />partecipate!
            </Link>
          </div>
          */}
          
          {/* Slide 2 - Fatima 17 */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px]">
            <div className="absolute inset-0">
              <img
                src={fatima17}
                alt="Fatima 17"
                className="w-full h-full object-cover object-[center_40%]"
              />
            </div>
            <p
              className="absolute top-[10%] left-[3%] sm:left-[4%] md:left-[5%] max-w-[42%] sm:max-w-[38%] md:max-w-[35%] z-10 text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl font-bold text-center leading-tight"
              style={{
                color: '#C41E1E',
                textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff, 0 0 8px rgba(255,255,255,0.9)'
              }}
            >
              Dietro ogni sorriso c'è una storia di coraggio silenzioso...
            </p>
            <p
              className="absolute top-[55%] right-[3%] sm:right-[4%] md:right-[5%] max-w-[42%] sm:max-w-[38%] md:max-w-[35%] z-10 text-sm sm:text-base md:text-xl lg:text-2xl xl:text-3xl font-bold text-center leading-tight"
              style={{
                color: '#C41E1E',
                textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff, 0 0 8px rgba(255,255,255,0.9)'
              }}
            >
              Aiutaci a far continuare la danza della vita!
            </p>
            <div className="w-full py-8 md:py-16 lg:py-20 relative z-10 h-full flex items-end justify-center pb-8 md:pb-12">
              <div className="max-w-5xl transform transition-all duration-700 translate-y-0 opacity-100 px-4 sm:px-6 md:px-8" style={{animation: 'fadeInUp 0.8s ease-out'}}>
                <div className="flex justify-center">
                  <Link
                    to="/sostienici"
                    className="group px-4 sm:px-5 md:px-7 py-2 sm:py-3 md:py-4 bg-green-700 hover:bg-green-800 text-white font-bold rounded-lg shadow-lg hover:shadow-green-700/30 hover:-translate-y-1 transition-all duration-300 flex items-center space-x-2"
                  >
                    <span>Sostienici</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          {/* Slide 3 - Progetto ADAMTS13 */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px]">
            <div className="absolute inset-0 flex items-center justify-center" style={{backgroundColor: '#ffffff'}}>
              <div className="text-center space-y-0 max-w-5xl px-4">
                <div className="-mb-8 sm:-mb-10 md:-mb-12">
                  <img
                    src={slide1}
                    alt="Robin Hood Roma"
                    className="w-auto max-w-full h-[140px] sm:h-[170px] md:h-[200px] lg:h-[240px] xl:h-[280px] object-contain mx-auto"
                    style={{marginBottom: '-30px'}}
                  />
                </div>
                <img
                  src={paperoSinistra}
                  alt=""
                  aria-hidden="true"
                  className="absolute top-[6%] left-[3%] sm:left-[5%] md:left-[7%] lg:left-[9%] h-[121px] sm:h-[154px] md:h-[187px] lg:h-[220px] xl:h-[264px] w-auto object-contain z-10 pointer-events-none"
                />
                <img
                  src={paperoDestra}
                  alt=""
                  aria-hidden="true"
                  className="absolute top-[6%] right-[3%] sm:right-[5%] md:right-[7%] lg:right-[9%] h-[127px] sm:h-[162px] md:h-[196px] lg:h-[231px] xl:h-[277px] w-auto object-contain z-10 pointer-events-none"
                />
                <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-primary leading-tight px-2">
                  PROGETTO ADAMTS13: I NOSTRI PAZIENTI CON LA PTT (PORPORA TROMBOTICA TROMBOCITOPENICA) CI CHIEDONO DI AIUTARLI
                </h2>
                <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-700 font-bold px-4">
                  Ogni contributo diventa cura: sostieni il progetto!
                </p>
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center pt-2 md:pt-3">
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="inline-block px-6 md:px-8 py-3 md:py-4 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 w-full sm:w-auto text-center"
                  >
                    Conosci la malattia e il progetto
                  </button>
                  <Link
                    to="/sostienici"
                    className="inline-block px-6 md:px-8 py-3 md:py-4 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 w-full sm:w-auto text-center"
                  >
                    Dai il tuo contributo
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          {/* Slide 4 */}
          <div className="relative w-full h-[255px] sm:h-[340px] md:h-[425px] lg:h-[510px] xl:h-[595px]">
            <div className="absolute inset-0">
              <img 
                src={slide2} 
                alt="Robin Hood Roma" 
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </Slider>
        )}
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-12 items-center">
            <div className="md:w-1/2 transform transition-all duration-500 hover:scale-[1.02]" data-aos="fade-right">
              <div className="relative rounded-xl overflow-hidden shadow-2xl">
                <img 
                  src={logoImage} 
                  alt="Volontari di Robin Hood Roma ODV" 
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-[#2E7D32]/80 to-transparent opacity-70 mix-blend-multiply"></div>
                <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-[#2E7D32] to-transparent opacity-40"></div>
                <div className="absolute -bottom-1 -right-1 w-20 h-20 bg-accent rounded-full blur-2xl opacity-60"></div> */}
              </div>
            </div>
            <div className="md:w-1/2" data-aos="fade-left" data-aos-delay="200">
              <h2 className="text-3xl font-bold text-primary mb-6 flex items-center">
                <span className="border-b-4 border-accent pb-2">Chi Siamo</span>
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                L'<b>Associazione Robin Hood Roma ODV</b> è un'organizzazione di volontariato costituita da genitori e da pazienti con malattie ematologiche rare, 
                seguiti presso l'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma.
              </p>
              <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                L'utilità sociale e la solidarietà sono la base sui quali si è costituita l'Associazione, il cui scopo è garantire a tutti i malati 
                ‒ bambini, adolescenti e adulti ‒ di poter usufruire dell'assistenza di cui hanno bisogno. L'idea "che nessun paziente abbia di meno" 
                anima lo spirito dei volontari, dei soci e di tutti coloro che operano in questa Associazione.
              </p>
              <Link to="/chi-siamo-storie" className="group px-6 py-3 bg-primary hover:bg-primary/90 text-white font-bold rounded-lg shadow-md hover:shadow-lg inline-flex items-center space-x-2 hover:-translate-y-1 transition-all duration-300">
                <span>La nostra <i>Mission</i></span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Storia Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-10">La Nostra Storia</h2>
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-primary hover:shadow-lg transition duration-300">
                <h3 className="text-xl font-bold text-primary mb-3">La fondazione - 2004</h3>
                <p className="text-gray-600 mb-4">
                  L'<b>Associazione Robin Hood Roma Onlus</b> nasce l'8 luglio 2004, per volontà di genitori dei bambini e degli adolescenti, 
                  seguiti presso l'Ematologia Pediatrica dell'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma.
                </p>
                <p className="text-gray-600">
                  Dalla sua fondazione fino all'ottobre 2022, l'Associazione ha aiutato economicamente famiglie di pazienti in difficoltà; 
                  ha acquistato presidi medicali e supportato il personale medico e infermieristico nei corsi di formazione.
                </p>
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-primary hover:shadow-lg transition duration-300">
                <h3 className="text-xl font-bold text-primary mb-3">La trasformazione - 2022</h3>
                <p className="text-gray-600 mb-4">
                  Nell'ottobre 2022, con la chiusura del reparto pediatrico, è stato deciso di proseguire l'attività dell'Associazione 
                  focalizzando l'attenzione nel supportare i pazienti con patologie rare ematologiche di qualsiasi età.
                </p>
                <p className="text-gray-600">
                  Trasmigrata nel RUNTS nel novembre 2022, l'<b>Associazione Robin Hood Roma ODV</b> è diventata, nel marzo 2024, 
                  una ODV, con un nuovo statuto ed ha acquisito personalità giuridica.
                </p>
              </div>
            </div>
            
            <div className="mt-8 bg-white rounded-lg shadow-md p-6 border-t-4 border-primary hover:shadow-lg transition duration-300">
              <h3 className="text-xl font-bold text-primary mb-3">Oggi</h3>
              <p className="text-gray-600">
                Dal 2022 a oggi, l'Associazione ha continuato a sostenere economicamente e a migliorare l'assistenza ai pazienti 
                con malattie rare seguiti in Ematologia: con l'acquisto di dispositivi medici (come elettrocardiografi, reagenti, etc); 
                a supportare medici e infermieri per migliorare la loro professionalità in ambiti specifici (trapianto di cellule 
                staminali e terapie innovative, etc).
              </p>
            </div>
            
            <div className="mt-8 text-center">
              <Link to="/chi-siamo-storie" className="inline-flex items-center px-6 py-3 bg-primary text-white font-bold rounded-lg shadow-md hover:bg-primary/90 transition-colors">
                Scopri la storia completa
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Programs Highlights */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">La Nostra <i>Mission</i></h2>
          
          <p className="text-gray-700 text-lg text-center mb-10 max-w-4xl mx-auto">
            L'Associazione, riconosciuta operante all'interno dell'AOU Policlinico Umberto I, vuole continuare nell'impegno a sostegno 
            di genitori e pazienti con patologie rare ematologiche, in armonia con gli operatori e le altre associazioni con cui collabora 
            e/o che operano nella stessa struttura. Gli obiettivi sono molteplici:
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Supporto Economico</h3>
              <p className="text-gray-600 mb-4">
                Supportare economicamente le necessità diagnostiche e/o terapeutiche di pazienti in difficoltà economiche.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Accesso ai Servizi</h3>
              <p className="text-gray-600 mb-4">
                Facilitare l'accesso ai servizi sulle malattie rare che operano in Ematologia, con un sito internet fruibile ed aggiornato, strutturato anche per favorire e promuovere la diffusione della conoscenza delle patologie rare di interesse ematologico.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Promozione Rapporti</h3>
              <p className="text-gray-600 mb-4">
                Stimolare e promuove i rapporti tra il personale medico, infermieristico, le famiglie e gli altri operatori del settore.
              </p>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Ricerca Scientifica</h3>
              <p className="text-gray-600 mb-4">
                Favorire la ricerca nel campo delle malattie ematologiche rare, promuovendo studi e ricerche sulle patologie rare di interesse ematologico e continuando a supportare infermieri e medici per convegni, riunioni e corsi di aggiornamento.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Collaborazione</h3>
              <p className="text-gray-600 mb-4">
                Incoraggiare i rapporti di collaborazione tra centri, adulti e pediatrici, nazionali e internazionali, nonché organizzazioni ed enti che perseguono scopi analoghi.
              </p>
            </div>



            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-accent hover:shadow-lg transition duration-300">
              <div className="bg-accent/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3">Supporto Psicologico</h3>
              <p className="text-gray-600 mb-4">
              Assicurare un supporto ricreativo e terapie di sostegno mirate al benessere dei pazienti, bambini e adulti, dei familiari e degli operatori della struttura.
              </p>
            </div>
            
                
            </div>
            </div>
          
      </section>
      
      {/* 5 x mille - Sezione dedicata */}
      <section className="py-20 bg-gradient-to-b from-blue-50 via-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-6">
            <div className="h-0.5 w-16 bg-gradient-to-r from-transparent to-green-700 mr-4"></div>
            <h2 className="text-3xl font-bold text-green-800 relative">
              Sostieni la nostra <i>Mission</i>
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-500"></span>
            </h2>
            <div className="h-0.5 w-16 bg-gradient-to-l from-transparent to-green-700 ml-4"></div>
          </div>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12 text-lg">
            Il tuo contributo è fondamentale per permetterci di continuare il nostro lavoro.
          </p>
          
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 group transition-all duration-300 hover:shadow-xl">
              <div className="bg-gradient-to-r from-green-700 to-green-800 py-5 px-8 text-white flex items-center justify-between relative overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-yellow-300 opacity-20 rounded-full transform -translate-y-20 translate-x-16 group-hover:translate-x-10 transition-transform duration-500"></div>
                <div className="flex items-center">
                  <span className="text-2xl font-bold mr-2">5</span>
                  <span className="text-xl font-semibold">x mille</span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-300 z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="p-8 md:p-10">
                <h3 className="text-2xl md:text-3xl font-bold text-green-800 mb-4 flex items-center">
                  <span className="mr-3">Sostienici con il tuo 5 x mille</span>
                  <div className="h-px flex-grow bg-gradient-to-r from-green-700 to-transparent opacity-30"></div>
                </h3>
                <p className="text-gray-700 mb-8 text-lg leading-relaxed">
                  Destinando all'<b>Associazione Robin Hood Roma ODV</b> il 5 x mille, contribuisci, senza alcun aggravio delle imposte,
                  a realizzare gli obiettivi dell'associazione. È un gesto di solidarietà, che può contribuire a migliorare la vita dei pazienti.
                </p>
                
                <div className="mb-10 py-6 px-8 bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-lg text-center border-l-4 border-yellow-500 shadow-sm transform hover:scale-[1.01] transition-transform">
                  <div className="text-sm uppercase tracking-wide text-green-800 font-medium mb-1">Codice Fiscale</div>
                  <div className="font-mono font-bold text-2xl md:text-3xl tracking-wider text-green-900 flex items-center justify-center space-x-1">
                    <span className="bg-white px-2 py-1 rounded shadow-sm">97353740588</span>
                  </div>
                </div>
                
                <div className="text-center">
                  <a href="/sostienici" className="inline-flex items-center justify-center px-8 py-4 bg-green-700 text-white font-bold rounded-lg shadow-md hover:bg-green-800 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg group">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Come donare</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* I Nostri Eventi */}
      <section className="py-20 bg-gradient-to-b from-green-50 to-white">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-6">
            <div className="h-0.5 w-16 bg-gradient-to-r from-transparent to-green-700 mr-4"></div>
            <h2 className="text-3xl font-bold text-green-800 relative">
              I Nostri Eventi
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-yellow-500"></span>
            </h2>
            <div className="h-0.5 w-16 bg-gradient-to-l from-transparent to-green-700 ml-4"></div>
          </div>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12 text-xl">
            Partecipa ai nostri eventi per conoscere il volto dell'Associazione, le nostre idee e la nostra Comunità.
          </p>
          
          <div className="text-center">
            <Link to="/eventi" className="inline-flex items-center px-5 py-3 bg-green-700 text-white font-semibold rounded-md hover:bg-green-800 transition-all duration-300 shadow-sm hover:shadow-md mt-4">
                      <span className="text-lg">Scopri di più</span>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
            </Link>
          </div>
        </div>
      </section>


      {/* Call to Action */}
      <section className="py-16 bg-green-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Unisciti alla nostra <i>Mission</i></h2>
          <div className="text-xl mb-8 max-w-3xl mx-auto">
            <p>Puoi aiutarci a fare di più per le persone con malattie rare ematologiche per le quali ci impegniamo ogni giorno:</p>
            <div className="my-4 font-bold text-2xl">DONA!</div>
            <p>Un contributo minimo può fare la differenza.</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/sostienici" className="px-8 py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-md transition duration-300">
              Dona ora
            </Link>
            <Link to="/volontari" className="px-8 py-4 bg-transparent hover:bg-white/20 border-2 border-white text-white font-bold rounded-md transition duration-300">
              Diventa volontario
            </Link>
            <Link to="/soci"  className="px-8 py-4 bg-red-500 hover:bg-red-600 text-white font-bold rounded-md transition duration-300">
              Diventa socio
            </Link>
          </div>
        </div>
      </section>

      {/* Modal ADAMTS13 */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="space-y-6">
          <div className="text-center">
            <img 
              src={slide1} 
              alt="Robin Hood Logo" 
              className="w-32 h-auto object-contain mx-auto mb-6"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-primary mb-2">
              PROGETTO ADAMTS13: UN AIUTO CONCRETO AI PAZIENTI CON LA PTT
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-4">
              (PORPORA TROMBOTICA TROMBOCITOPENICA)
            </h2>
            <p className="text-lg text-gray-700 italic mb-6">Dott.ssa Silvia Trisolini</p>
          </div>

          <section>
            <h3 className="text-2xl font-bold text-red-600 mb-4">Conosci la malattia</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                La porpora trombotica trombocitopenica (PTT), meglio conosciuta come Sindrome di Moschowitz, è una rara malattia che colpisce prevalentemente giovani e bambini ed è gravata da una elevata mortalità se non prontamente trattata. Nella maggior parte dei casi è una patologia autoimmune per cui vengono prodotti degli autoanticorpi contro l'enzima ADAMTS13.
              </p>
              <p>
                Alla base della patologia, vi è <span className="text-red-600 font-semibold">una deficiente attività dell'enzima ADAMTS13</span> una metalloproteasi che ha lo scopo di tagliare i multimeri ultra-large del fattore di von Willebrand, esposti in seguito ad un danno endoteliale dovuto a cause infettive, farmaci, traumi, interventi chirurgici. Ciò <span className="text-red-600 font-semibold">determina una iper-aggregazione piastrinica</span> con conseguente formazione di trombi nella microcircolazione e <span className="text-red-600 font-semibold">danni ischemici tissutali</span> a livello di tutti gli organi soprattutto <span className="text-red-600 font-semibold">cuore, cervello e intestino</span>. Per questo la malattia è gravata da un elevato rischio di mortalità e morbidità.
              </p>
              <p>
                Vi è una <span className="text-red-600 font-semibold">forma autoimmune (iTTP) acquisita</span> in cui vi è la produzione di autoanticorpi che inibiscono l'attività dell'ADAMTS13 la iTTP è la forma più frequente e comune soprattutto nei giovani adulti. Vi è una forma più rara quella <span className="text-red-600 font-semibold">congenita (cTTP)</span> più frequente nei bambini, alla base della quale vi è una o più mutazioni genetiche ereditarie che coinvolgono il gene che codifica per l'ADAMTS13, per cui la metalloproteasi non è prodotta oppure è deficiente.
              </p>
              <p>
                La <span className="text-red-600 font-semibold">diagnosi</span> della malattia viene sospettata su base clinica, quando presente anemia emolitica microangiopatica e piastrinopenia, ma viene poi <span className="text-red-600 font-semibold">confermata attraverso il dosaggio dell'attività dell'ADAMTS13</span> che deve essere &lt;10% e <span className="text-red-600 font-semibold">la ricerca degli autoanticorpi</span>.
              </p>
              <p>
                La terapia cardine della PTT autoimmune è la plasma-exchenge (PEX) che ha lo scopo di rimuovere gli anticorpi circolanti e rifornire di ADAMTS13 attraverso lo scambio con plasma fresco congelato, la terapia steroidea come immunosoppressore e il Caplacizumab nano anticorpo che ha la capacità di impedire l'aggregazione piastrinica al fattore di von Willebrand ed impedisce le ischemie tissutali dovute alla formazione dei trombi nella microcircolazione, riducendo così la mortalità. Mentre per la forma congenita la terapia cardine è l'infusione di plasma fresco congelato, a breve sarà disponibile in commercio l'ADAMTS13 ricombinante come terapia sostitutiva.
              </p>
              <p className="font-semibold">
                Il <span className="text-red-600">trattamento tempestivo</span> sia della forma acquisita che di quella congenita riduce drasticamente la mortalità e morbidità della malattia.
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg">
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                E' pertanto fondamentale avere a disposizione <span className="text-red-600 font-semibold">il dosaggio dell'attività</span> dell'ADAMTS13 per confermare o meno la diagnosi e per ridurre i costi nel caso di una diagnosi alternativa. Dopo la risposta al trattamento è importante il monitoraggio dell'attività dell'ADAMTS13 come da indicazione delle recenti linee guida, soprattutto nella forma acquisita autoimmune.
              </p>
              <p>
                Infatti, una riduzione dell'attività &lt;10% dell'enzima espone il paziente ad un elevato rischio di ricaduta della malattia. In questi casi è importante fare una terapia immunosoppressiva per prevenire la recidiva.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-red-600 mb-4">Conosci il progetto</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                La Ematologia, centro di riferimento regionale per questa patologia, <span className="text-red-600 font-semibold">non è possibile eseguire il test per l'attività dell'ADAMTS13</span> e la ricerca di autoanticorpi negli 81 pazienti seguiti, pur avendo a disposizione la strumentazione e l'expertise tecnica, <span className="text-red-600 font-semibold">per la mancanza di reagenti</span>. Questo è dovuto al fatto che tali test, pur essendo previsti dalle guida per la gestione della malattia, non sono stati ancora inseriti nei LEA e quindi non sono attualmente rimborsabili, ma si possono eseguire solo con fondi privati, con l'impossibilità di avere i risultati in tempo reale.
              </p>
              <p>
                Nel laboratorio di coagulazione dell'Ematologia è già presente uno strumento con il quale, utilizzando reagenti specifici, è possibile eseguire il test dell'attività dell'ADAMTS13 e la ricerca degli anticorpi.
              </p>
              <p>
                Avendo pertanto in laboratorio già presente l'apparecchiatura e l'expertise tecnica per eseguire le analisi e per la refertazione dei risultati, l'Associazione Robin Hood Roma ODV si è impegnata per l'acquisto dei reagenti specifici per eseguire attività e ricerca anticorpi anti ADAMTS13.
              </p>
            </div>
          </section>

          <section className="bg-red-50 p-6 rounded-lg">
            <h4 className="text-xl font-bold text-primary mb-4">Impegno economico annuo</h4>
            <p className="text-gray-700 mb-4">Di seguito si presenta una stima dell'impegno economico annuo dell'associazione, basata sull'attuale numero di 81 pazienti:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Per il dosaggio dell'enzima, sono necessari <strong>10 kits all'anno</strong> (ogni kit da 25 test costa 5.000 euro = <strong className="text-red-600">50.000 euro</strong>)</li>
              <li>Per il dosaggio degli anticorpi, servono <strong>2 kits all'anno</strong> (ogni kit da 96 test costa 835 Euro = <strong className="text-red-600">1.670 Euro</strong>).</li>
            </ul>
          </section>

          <section className="bg-green-50 p-6 rounded-lg border-l-4 border-primary">
            <p className="text-gray-700 text-lg font-semibold">
              Nonostante l'impegno economico significativo (<strong className="text-red-600">oltre 50.000 euro annui</strong>), l'Associazione Robin Hood Roma ODV ritiene il progetto di estrema importanza, perché permette un'adeguata e tempestiva assistenza a tutti i bambini e agli adulti affetti da questa rara malattia.
            </p>
          </section>

          <div className="text-center pt-6">
            <Link
              to="/sostienici"
              onClick={() => setIsModalOpen(false)}
              className="inline-block px-8 py-4 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Sostieni il Progetto
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Home;

